import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Navbar() {
  const userRole = localStorage.getItem("user_role");
  const navigate = useNavigate();

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (dropdownName) => {
    if (openDropdown === dropdownName) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(dropdownName);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".dropdown")) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <nav className="bg-gray-800 text-white">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16 relative">
          {/* Static Name at the Start */}
          <div className="flex items-center">
            <a href="/Home" className="text-gray-300 font-bold text-xl">
              {localStorage.getItem("company_name") || " "}
            </a>
          </div>

          {/* Middle: Menu Items */}
          <div className="hidden md:flex space-x-4">
            <div className="relative dropdown">
              <button
                className="hover:bg-gray-700 px-3 py-2 rounded-md flex items-center"
              >
                <a href="/home">Home</a>

              </button>

            </div>
            <div className="relative dropdown">
              <button
                className="hover:bg-gray-700 px-3 py-2 rounded-md flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown("master");
                }}
              >
                Master
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openDropdown === "master" && (
                <div className="absolute left-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg">
                  <a href="/CoMaster" className="block px-4 py-2 hover:bg-gray-200">C/O Master</a>
                  <a href="/UnitMaster" className="block px-4 py-2 hover:bg-gray-200">Unit Master</a>
                  <a href="/ItemMaster" className="block px-4 py-2 hover:bg-gray-200">Item Master</a>
                  <a href="/TaxMaster" className="block px-4 py-2 hover:bg-gray-200">Tax Master</a>
                </div>
              )}
            </div>

            <div className="relative dropdown">
              <button
                className="hover:bg-gray-700 px-3 py-2 rounded-md flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown("transactions");
                }}
              >
                Transactions
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openDropdown === "transactions" && (
                <div className="absolute left-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg">
                  <a href="/Home" className="block px-4 py-2 hover:bg-gray-200">Quotation</a>
                </div>
              )}
            </div>

            <div className="relative dropdown">
              <button
                className="hover:bg-gray-700 px-3 py-2 rounded-md flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown("reports");
                }}
              >
                Reports
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openDropdown === "reports" && (
                <div className="absolute left-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg">
                  <a href="/QuotationRegisters" className="block px-4 py-2 hover:bg-gray-200">Quotation Register</a>
                </div>
              )}
            </div>

            <div className="relative dropdown">
              <button
                className="hover:bg-gray-700 px-3 py-2 rounded-md flex items-center"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDropdown("setup");
                }}
              >
                Setup
                <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {openDropdown === "setup" && (
                <div className="absolute left-0 mt-2 w-48 bg-white text-black rounded-md shadow-lg">
                  <a href="/CompanyInfo" className="block px-4 py-2 hover:bg-gray-200">Company Information</a>
                  <a href="/ChangePass" className="block px-4 py-2 hover:bg-gray-200">Change Password</a>
                  {userRole === "1" && (
                    <a href="/UserList" className="block px-4 py-2 hover:bg-gray-200">User List</a>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Right Side: Account/Logout */}
          <div className="flex items-center space-x-4">
            <span className="text-gray-300 hidden sm:block">
              {localStorage.getItem("full_name") || " "}
            </span>
            <button onClick={logout} className="hover:bg-gray-700 px-3 py-2 rounded-md">
              Logout
            </button>
          </div>

          {/* Hamburger Menu for Mobile */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setOpenDropdown(openDropdown === "menu" ? null : "menu")}>
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* Mobile Dropdown Menu */}
          {openDropdown === "menu" && (
            <div className="absolute top-16 left-0 w-full bg-gray-800 md:hidden">
              <div className="flex flex-col space-y-2 px-4 py-2">
                <a href="/CoMaster" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">C/O Master</a>
                <a href="/UnitMaster" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">Unit Master</a>
                <a href="/ItemMaster" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">Item Master</a>
                <a href="/Home" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">Quotation</a>
                <a href="/QuotationRegisters" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">Quotation Register</a>
                <a href="/CompanyInfo" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">Company Information</a>
                <a href="/ChangePass" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">Change Password</a>
                {userRole === "1" && (
                  <a href="/UserList" className="block px-4 py-2 text-gray-300 hover:bg-gray-700 rounded-md">User List</a>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
